import templates from './templates';
import { replace } from 'lodash';

const templateAlias = {
  'partner-covalent': 'covalent',
  'partner-twyne': 'twyne',
  'partner-ifficient': 'ifficient',
  'partner-permissiondata': 'permissiondata',
  'partner-optintelligence': 'optintelligence',
  'partner-tiburon': 'tiburon',
  'partner-react2': 'react2',
  'partner-rexadz': 'rexadz',
  'partner-nitro': 'nitro',
  'partner-fluent': 'fluent',
  'tcpa-linkout-question': 'linkoutquestion',
  'tcpa-call-question': 'callquestion',
  'tcpa-question': 'tcpaquestion',
  'tcpa-question-custom': 'tcpaquestioncustom',
  'tcpa-confirmation': 'tcpaconfirmation',
  'tcpa-form': 'tcpaform',
  'account-pw': 'accountpassword',
};

const typeOptions = [
  { value: 'iframe', label: 'iframe' },
  { value: 'html', label: 'HTML' },
  { value: 'partner-ifficient', label: 'Ifficient' },
  { value: 'partner-twyne', label: 'Twyne' },
  { value: 'partner-covalent', label: 'Covalent' },
  { value: 'partner-permissiondata', label: 'Permission Data' },
  { value: 'partner-optintelligence', label: 'Opt-Intelligence' },
  { value: 'partner-tiburon', label: 'Tiburon' },
  { value: 'partner-react2', label: 'React2Media' },
  { value: 'partner-rexadz', label: 'RexAdz' },
  { value: 'partner-nitro', label: 'Nitro' },
  { value: 'partner-fluent', label: 'Fluent' },
  { value: 'tcpa-linkout-question', label: 'Linkout Question' },
  { value: 'tcpa-call-question', label: 'ClickToCall Question' },
  { value: 'tcpa-question', label: 'TCPA Question' },
  { value: 'tcpa-question-custom', label: 'TCPA Question Custom' },
  { value: 'tcpa-confirmation', label: 'TCPA Confirmation' },
  { value: 'tcpa-form', label: 'TCPA Form' },
  { value: 'account-pw', label: 'Account Password' },
];

const generatePlacement = (type, integrationData) => {
  if (integrationData.vendorPlacement && templateAlias[type] === 'rexadz') {
    let content = integrationData.vendorPlacement;
    return replaceRexadz(content)
      .replace("wsid", integrationData[templateAlias[type]]['placementid'])
      .replace("fname", "{firstName_urlencoded}")
      .replace("lname", "{lastName_urlencoded}")
      .replace("email", "{email_urlencoded}")
      .replace("phone", "{phone_urlencoded}")
      .replace("zip", "{zip_urlencoded}")
      .replace("redirect", "{nextURL_urlencoded}")
      .replace("s1", "{pe_key}")
      .content();
  }

  return templates[templateAlias[type]](integrationData[templateAlias[type]], (integrationData || {}) );
};

const replaceRexadz = (content) => {
  const regex = /(<iframe.+?src=)("(.*?)"|'(.*?)')(.+)/
  const replaces = []

  return {
    content() {
      if (!regex.test(content))
        throw 'iframe[src] is missing'

      return content.replace(regex, ($0, $1, $2, $3, $4, $5) => {
        let url = $3 || $4
        try {
          url = new URL(url, 'https://www')
        } catch (e) {
          throw 'URL invalid'
        }
        if (!url.hostname.includes('rexadz.com'))
          throw 'URL must be from domain rexadz.com'

        for (let [param, replace] of replaces) {
          url.searchParams.set(param, replace)
        }
        return `${$1}${(decodeURI(url.href))}${$5}`
      })
    },
    replace(param, replace) {
      replaces.push([param, replace])
      return this
    }
  }
}

const replaceWithRegex = (txt, param, replace, upsert) => {
  const regex = new RegExp('(' + param + '=).*?(&)');
  const regexUpsert = /(<iframe\s+src=")(.*?)(")/g;

  if (txt.match(regex)) {
    return txt.replace(regex, '$1' + replace + '$2');
  } else if (upsert === true && txt.match(regexUpsert)) {
    // append the parameter
    return txt.replace(regexUpsert, '$1$2&'+param+'='+replace+'$3');
  }

  return txt;
}

export {
  typeOptions,
  generatePlacement,
  templateAlias
};
